module.exports = __webpack_public_path__ + "img/12_dice[9].5cf3bec1.png";